const Constants = {
    applicationVersion: "1.1.3",
    menuPathMetadataKey: "MENU_PATH",
    itemMetadataKey: "ITEM",
    submenuRedirectMetadataKey: "submenu_redirect",
    propertyGroupsMetadataKey: "property_groups",
    defaultServiceUrlLocalhost: "http://localhost/SISCC_DEV",
    configuratorUrlPath: "/configurator",
    serviceUrlQueryParam: "service_url",
    languageUrlQueryParam: "lang",
    marketUrlQueryParam: "market",
    dealerAccountUrlQueryParam: "dealer_id",
    sideMenuWidth: 253,
    mobileImageHeightVw: 55,
    desktopImageHeightPercent: 80,
    customerEmailSubjectSettingsKey: "PDF_EMAIL_CUSTOMER_SUBJECT",
    customerEmailBodySettingsKey: "PDF_EMAIL_CUSTOMER_BODY_HTML",
    menuItemWidth: 93,
    menuItemHeight: 176,
    menuItemPriceHeight: 44,
    menuItemMarginRight: 18,
    menuItemmargeinBottom: 10,
};

export default Constants;
